var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.9881,
    cy: 8,
    rx: 7.9881,
    ry: 8,
    fill: "#00B71E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80362 7.13557L8.81774 6.14822C8.71825 6.04858 8.78871 5.87822 8.92941 5.87822L9.83358 5.87822C9.96593 5.87822 10.0732 5.98567 10.0732 6.11822L10.0732 7.02373C10.0732 7.16464 9.90311 7.2352 9.80362 7.13557Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31068 6.64189L6.00635 9.95115M8.81774 6.14822L9.80362 7.13557C9.90311 7.2352 10.0732 7.16464 10.0732 7.02373L10.0732 6.11822C10.0732 5.98567 9.96593 5.87822 9.83358 5.87822L8.92941 5.87822C8.78871 5.87822 8.71825 6.04858 8.81774 6.14822Z",
    stroke: "white",
    strokeWidth: 0.675663,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/In.6d334b7d238f1ca0a3983be22c4ffd5a.svg";
export { ForwardRef as ReactComponent };